import { PreventivoRow } from "../services/preventiviApi";

/**
 * Righe con codice "Nuovo Prezzo" (NP.*): il backend le esclude sempre dal
 * matching automatico e richiedono un abbinamento manuale. Stesso pattern
 * usato lato backend (np_codes.py) — generico su "NP", non solo "NP.IE".
 */
const NP_PATTERN = /^\s*NP[\s._-]*[A-Z]{0,4}[\s._-]*\d/i;

export const isNpRow = (row: PreventivoRow): boolean =>
  !!row.code && NP_PATTERN.test(row.code);
